import { Card, CircularProgress, useTheme } from "@material-ui/core";
import styles from "./HosErrorIndicator.module.css";

export const HosPendingIndicator = () => {
  const theme = useTheme();

  return (
    <div className={styles["error-indicator"]}>
      <Card style={{ background: theme.palette.background.paper }}>
        <div className={styles["card-wrapper"]}>
          <CircularProgress size={24} />
          <div className={styles["card-message"]}>
            Hours of service are being recalculated. We will keep checking for
            updates.
          </div>
        </div>
      </Card>
    </div>
  );
};
